module.exports = __webpack_public_path__ + "static/media/logo365x139.f454c69f.png";